export const EMAIL_TEMPLATE_ACTIONS = {
  DELETE: 'delete',
  DUPLICATE: 'duplicate',
  EDIT: 'edit',
  CREATE: 'create',
};

export const EMAIL_TEMPLATE_STATUS = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
};

export const EMAIL_TEMPLATE_STATUS_MAPPING = {
  [EMAIL_TEMPLATE_STATUS.ACTIVE]: { color: 'green', displayName: 'Active' },
  [EMAIL_TEMPLATE_STATUS.DRAFT]: { color: 'blue', displayName: 'Draft' },
};

export const EMAIL_TEMPLATE_VISIBILITY = {
  PRIVATE: 'private',
  PUBLIC: 'public',
};

export const EMAIL_TEMPLATE_GROUP_KEY = {
  ALL: 'all',
  PRIVATE: 'private',
  PUBLIC: 'public',
};

export const fontList = [
  'Arial',
  'Tahoma',
  'Verdana',
  'Times New Roman',
  'Courier New',
  'Georgia',
  'Lato',
  'Montserrat',
].map((item) => ({ value: item, label: item }));
